var _g, _rect, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1027_9709)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 27,
    r: 20,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1027_9709",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 12,
    width: 29,
    height: 29
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.873,
    y: 12.873,
    width: 27.4074,
    height: 27.4074,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1027_9709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1778 31.6867L34.4309 28.2037C34.6022 28.0895 34.6878 27.9277 34.6878 27.7184C34.6878 27.509 34.6022 27.3472 34.4309 27.233L29.1778 23.75C28.9875 23.6168 28.7924 23.6025 28.5925 23.7072C28.3927 23.8118 28.2928 23.9784 28.2928 24.2068V31.2299C28.2928 31.4583 28.3927 31.6249 28.5925 31.7295C28.7924 31.8342 28.9875 31.8199 29.1778 31.6867ZM28.2928 16.2986C27.9692 16.2986 27.698 16.1892 27.4791 15.9703C27.2602 15.7514 27.1508 15.4802 27.1508 15.1566C27.1508 14.8331 27.2602 14.5618 27.4791 14.343C27.698 14.1241 27.9692 14.0146 28.2928 14.0146H32.8607C33.1842 14.0146 33.4555 14.1241 33.6743 14.343C33.8932 14.5618 34.0027 14.8331 34.0027 15.1566C34.0027 15.4802 33.8932 15.7514 33.6743 15.9703C33.4555 16.1892 33.1842 16.2986 32.8607 16.2986H28.2928ZM30.5767 37.9961C29.1683 37.9961 27.8407 37.7249 26.5941 37.1825C25.3474 36.64 24.2578 35.9025 23.3252 34.9699C22.3926 34.0373 21.655 32.9476 21.1126 31.701C20.5702 30.4543 20.299 29.1268 20.299 27.7184C20.299 26.3099 20.5702 24.9824 21.1126 23.7357C21.655 22.4891 22.3926 21.3994 23.3252 20.4668C24.2578 19.5342 25.3474 18.7967 26.5941 18.2542C27.8407 17.7118 29.1683 17.4406 30.5767 17.4406C31.7568 17.4406 32.8892 17.6309 33.9741 18.0116C34.7128 18.2708 35.4206 18.6094 36.0975 19.0274C36.6486 19.3677 37.3703 19.326 37.8283 18.868C38.0376 18.6587 38.3041 18.554 38.6277 18.554C38.9512 18.554 39.2177 18.6587 39.427 18.868C39.6364 19.0774 39.7411 19.3439 39.7411 19.6674C39.7411 19.991 39.6364 20.2574 39.427 20.4668C38.9691 20.9248 38.9274 21.6465 39.2677 22.1975C39.6857 22.8745 40.0243 23.5823 40.2835 24.321C40.6642 25.4059 40.8545 26.5383 40.8545 27.7184C40.8545 29.1268 40.5833 30.4543 40.0408 31.701C39.4984 32.9476 38.7609 34.0373 37.8283 34.9699C36.8957 35.9025 35.806 36.64 34.5594 37.1825C33.3127 37.7249 31.9852 37.9961 30.5767 37.9961Z",
    fill: "#A7BBD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1778 31.6867L34.4309 28.2037C34.6022 28.0895 34.6878 27.9277 34.6878 27.7184C34.6878 27.509 34.6022 27.3472 34.4309 27.233L29.1778 23.75C28.9875 23.6168 28.7924 23.6025 28.5925 23.7072C28.3927 23.8118 28.2928 23.9784 28.2928 24.2068V31.2299C28.2928 31.4583 28.3927 31.6249 28.5925 31.7295C28.7924 31.8342 28.9875 31.8199 29.1778 31.6867ZM28.2928 16.2986C27.9692 16.2986 27.698 16.1892 27.4791 15.9703C27.2602 15.7514 27.1508 15.4802 27.1508 15.1566C27.1508 14.8331 27.2602 14.5618 27.4791 14.343C27.698 14.1241 27.9692 14.0146 28.2928 14.0146H32.8607C33.1842 14.0146 33.4555 14.1241 33.6743 14.343C33.8932 14.5618 34.0027 14.8331 34.0027 15.1566C34.0027 15.4802 33.8932 15.7514 33.6743 15.9703C33.4555 16.1892 33.1842 16.2986 32.8607 16.2986H28.2928ZM30.5767 37.9961C29.1683 37.9961 27.8407 37.7249 26.5941 37.1825C25.3474 36.64 24.2578 35.9025 23.3252 34.9699C22.3926 34.0373 21.655 32.9476 21.1126 31.701C20.5702 30.4543 20.299 29.1268 20.299 27.7184C20.299 26.3099 20.5702 24.9824 21.1126 23.7357C21.655 22.4891 22.3926 21.3994 23.3252 20.4668C24.2578 19.5342 25.3474 18.7967 26.5941 18.2542C27.8407 17.7118 29.1683 17.4406 30.5767 17.4406C31.7568 17.4406 32.8892 17.6309 33.9741 18.0116C34.7128 18.2708 35.4206 18.6094 36.0975 19.0274C36.6486 19.3677 37.3703 19.326 37.8283 18.868C38.0376 18.6587 38.3041 18.554 38.6277 18.554C38.9512 18.554 39.2177 18.6587 39.427 18.868C39.6364 19.0774 39.7411 19.3439 39.7411 19.6674C39.7411 19.991 39.6364 20.2574 39.427 20.4668C38.9691 20.9248 38.9274 21.6465 39.2677 22.1975C39.6857 22.8745 40.0243 23.5823 40.2835 24.321C40.6642 25.4059 40.8545 26.5383 40.8545 27.7184C40.8545 29.1268 40.5833 30.4543 40.0408 31.701C39.4984 32.9476 38.7609 34.0373 37.8283 34.9699C36.8957 35.9025 35.806 36.64 34.5594 37.1825C33.3127 37.7249 31.9852 37.9961 30.5767 37.9961Z",
    stroke: "#7DA7B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1027_9709",
    x: 0.783784,
    y: 0.189189,
    width: 60.4324,
    height: 60.4324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.40541
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.10811
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.490196 0 0 0 0 0.654902 0 0 0 0 0.72549 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1027_9709"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1027_9709",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIcon);
export default __webpack_public_path__ + "static/media/audio-icon.564ab4ec63460e0a54de2be05f52e85f.svg";
export { ForwardRef as ReactComponent };